<script setup lang="ts">
import { ElPagination } from 'element-plus';
import { computed } from 'vue';

const props = defineProps({
  currentPage: Number,
  pageSize: Number,
  total: Number,
  pageSizes: {type: Array, required: false, default: ()=>{return [10, 15, 20, 25]}},
  layout: {type: String, required: false, default: 'prev, pager, next, jumper, ->, total'},
})

const emit = defineEmits(['update:pageSize', 'update:currentPage', 'size-change', 'current-change'])

// 利用prop+computed实现双向绑定
const _currentPage: any = computed( {
  get() {
    return props.currentPage
  },
  set(val) {
    emit('update:currentPage', val)
  }
})
const _pageSize: any = computed( {
  get() {
    return props.pageSize
  },
  set(val) {
    emit('update:pageSize', val)
  }
})

const sizeChange = (val: number) => {
  // console.log('sizeChange:', val)
  emit('size-change', val)
}
const currentChange = (val: number) => {
  // console.log('currentChange:', val)
  emit('current-change', val)
}
</script>

<template>
  <div class="spm-pagination">
    <ElPagination
      v-model:current-page="_currentPage"
      v-model:page-size="_pageSize"
      class="w-full"
      small
      background
      :page-sizes="pageSizes"
      :total="total" 
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="sizeChange"
      @current-change="currentChange" />
  </div>
</template>

<style lang="less" scoped>
.el-pagination {
  :deep(.el-pagination__total) {
    color: var(--c-gray-dark);
    font-size: 14px;
  }
  :deep(.el-pagination__sizes) {
    margin-right: auto;
    .el-input__wrapper {
      box-shadow: none;
      border-radius: 3px;
      background-color: var(--pagination-page-sizing-bg-color);
      color: var(--pagination-page-sizing-text-color);
      font-size: 14px;
    }
    .el-input__wrapper.is-focus {
      box-shadow: none !important;
    }
  }
  :deep(.el-pager) {
    li:not(.is-disabled).is-active {
      background-color: var(--left-menu-text-active-color);
    }
  }
  :deep(.el-pagination__jump) {
    font-size: 14px;
    color: var(--c-gray-dark);
  }
}
</style>